<template>
  <div class="match-2021m" style="position: relative">
    <div
      class="bannerM-0204"
      style="margin-top: 50px"
      onclick='javascript:window.open("http://univ.ciciec.com/col.jsp?id=116","_blank")'
    >
      <img src="@/assets/myMatch/2021p/banner750x420_20210721.jpg" />
    </div>

    <div class="container0204 ssjj-mlj" style="background-color: #f1f2f5">
      <div class="title-font28-0204">赛事简介</div>
      <div class="title-bgimg-0204" style="margin-bottom: 30px"></div>
      <div style="margin-bottom: 30px">
        <img src="@/assets/myMatch/2021p/1saishijianjie_img.jpg" width="100%" />
      </div>
      <div class="font14-0204">
        <p class="mgb10">
          2021年1月中旬，海云捷迅及重庆邮电大学执行承办的第五届全国大学生集成电路创新创业大赛启动仪式在西部（重庆）科学城举行。该活动由工业和信息化部人才交流中心主办，重庆高新技术产业开发区管理委员会承办，重庆西永微电子产业园区、重庆高新区创新服务中心、示范性微电子学院产学融合发展联盟、IEEE中国代表处、北京电子学会协办。
        </p>
        <p>
          作为本次大赛中的执行承办方，海云捷迅将提供人工智能边缘实验平台作为本次大赛的赛事平台，并参与赛题设置。海云捷迅将倾力参与到大赛中，为参赛团队提供服务。
        </p>
      </div>
    </div>

    <div class="contentBacImg">
      <!-- 大赛培训 -->
      <div class="container0204 dspx-wrapper">
        <div class="awcloudCompetTrain_head">
          <div class="title-font28-0204">大赛培训</div>
          <div class="title-bgimg-0204"></div>
        </div>

        <div class="awcloudCompetTrain_content">
          <div class="awcloudCompetTrain_imgBox">
            <img src="@/assets/myMatch/2021p/dasaipeixun_img.jpg" alt="" />
          </div>
          <h3 class="awcloudCompetTrain_title">
            第五届全国大学生集成电路创新创业大赛——线上宣讲会
          </h3>
          <p class="awcloudCompetTrain_Sessions">
            集创赛赛前宣讲第四场——FPGA 设计与应用赛道
          </p>
          <p class="awcloudCompetTrain_number">
            2347 人次学习 直播时间： 2021.03.01 14:00:00
          </p>
          <div class="awcloudCompetTrain_buttonBox">
            <button
              class="awcloudCompetTrain_button"
              onclick="javascript:window.open('https://appuyuimady2642.pc.xiaoe-tech.com/detail/l_6038b2e2e4b0b6e9418e12a2/4?from=p_600fb791e4b0f176aecb0283&type=8','_blank')"
            >
              进入回看
            </button>
            <div class="awcloudCompetTrain_free">免费</div>
          </div>
          <div class="awcloudCompetTrain_course">
            <p>第五届集创赛培训相关课程持续更新ing 敬请关注!</p>
          </div>
        </div>
      </div>

      <div class="container0204 hyjxb-wrapper">
        <div class="title-font28-0204">海云捷迅杯</div>
        <div class="title-bgimg-0204"></div>
        <div class="title-text-0204">
          海云捷迅作为企业代表参与赛题设置，<br />大赛中开设“海云捷迅杯”赛道
        </div>
        <div class="hyjxb-container">
          <div class="content-col18">
            <div class="content-col18-bg"></div>
            <div style="color: #999">杯赛题目</div>
          </div>
          <div
            style="
              margin-bottom: 40px;
              font-size: 20px;
              color: #333;
              font-weight: bold;
              line-height: 34px;
            "
          >
            基于FPGA C5Soc的MobileNet<br />V1 SSD目标检测方案设计
          </div>
          <div class="content-col18">
            <div class="content-col18-bg"></div>
            <div style="color: #999">参赛组别</div>
          </div>
          <div
            style="
              font-size: 20px;
              color: #333;
              font-weight: bold;
              line-height: 34px;
            "
          >
            B组
          </div>
        </div>
        <div class="hyjxb-container">
          <div class="content-col18">
            <div class="content-col18-bg"></div>
            <div style="color: #999">设计任务</div>
          </div>
          <div class="font14-0204">
            <p class="mgb10">
              1. 基于已训练好的SSD模型参数文件、基于已有的Intel FPGA工程网表文件、Linux-C5soc平台的Paddle-Paddle框架驱动为参考，优化或者重新设计加速器以及对应驱动，并部署SSD模型到FPGA进行推理
            </p>
            <p class="mgb10">2. 对方案进行评估和实现</p>
            <p class="mgb10">3. 提出设计方案，提升性能并实现</p>
            <p class="mgb10">
              4. 基础部分100，附加部分40分。最后总分按两部分相加得到
            </p>
            <p style="font-size: 13px; color: #999">
              备注：SSD模型参数文件、工程网表文件，包括整个工程结构顶层以及各模块连接关系，包括卷积、全连接等算子以及互联矩阵、调度模块等CNN加速器的完整工程。
            </p>
          </div>
        </div>
        <div class="hyjxb-container">
          <div class="content-col18">
            <div class="content-col18-bg"></div>
            <div style="color: #999">设计指标</div>
          </div>
          <div class="font14-0204">
            <p class="mgb10">
              1. 模型部署完成，能正确识别图片数据，推理时间1s以内
            </p>
            <p>2. 完成方案设计，完成方案设计文稿</p>
          </div>
        </div>
        <div class="hyjxb-container">
          <div class="content-col18">
            <div class="content-col18-bg"></div>
            <div style="color: #999">附加题</div>
          </div>
          <div class="font14-0204">
            <p class="mgb10">
              根据提供的网表和驱动文件，根据Demo工程重新设计加速器底层Verilog工程结构及相应驱动
            </p>
          </div>
          <div>
            <table class="fjt-table">
              <thead>
                <tr>
                  <th>性能/帧率(FPS)</th>
                  <th>分值</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2</td>
                  <td>10</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>13</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>16</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>20</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>22</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>24</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>26</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>28</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>32</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>34</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>36</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>38</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>40</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="hyjxb-container">
          <div class="content-col18">
            <div class="content-col18-bg"></div>
            <div style="color: #999">提交内容</div>
          </div>
          <div class="font14-0204">
            <p class="mgb10">1. 汇报PPT：项目介绍、关键技术介绍、性能指标</p>
            <p class="mgb10">
              2. 详细设计方案：系统架构分析、关键技术分析、性能分析
            </p>
            <p>3. 驱动源码以及底层Verilog工程源码、仿真以及测试报告</p>
          </div>
        </div>
        <div class="hyjxb-container" style="margin-bottom: 40px">
          <div class="content-col18">
            <div class="content-col18-bg"></div>
            <div style="color: #999">评分标准</div>
          </div>
          <div class="awcloudCup_SorePip">
            <table>
              <thead>
                <tr>
                  <th class="awcloudCup_SorePipContent">内容</th>
                  <th class="awcloudCup_SorePipSore">分值</th>
                  <th
                    class="awcloudCup_SorePipRequire"
                    style="padding-left: 20px"
                  >
                    评分要求
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="2" class="awcloudCup_SorePipBac">1.性能指标</td>
                  <td rowspan="2" class="awcloudCup_SorePipBac">40分</td>
                  <td>1.能正确的实现模型部署，并达到帧率(1FPS)要求。30分</td>
                </tr>
                <tr>
                  <td>2.FPGA工程时序稳定、结构合理，源码及命名规范。10分</td>
                </tr>
                <tr>
                  <td rowspan="3" class="awcloudCup_SorePipBac">
                    2.设计完整性
                  </td>
                  <td rowspan="3" class="awcloudCup_SorePipBac">30分</td>
                  <td>1.完整的设计方案。10分</td>
                </tr>
                <tr>
                  <td>2.完整的源码工程以及注释。10分</td>
                </tr>
                <tr>
                  <td>3.完整的仿真以及测试报告。10分</td>
                </tr>
                <tr>
                  <td rowspan="3" class="awcloudCup_SorePipBac">3.文档质量</td>
                  <td rowspan="3" class="awcloudCup_SorePipBac">20分</td>
                  <td>1. 汇报PPT重点突出、条理清晰。5分</td>
                </tr>
                <tr>
                  <td>2. 设计方案原理分析合理、逻辑清晰。5分</td>
                </tr>
                <tr>
                  <td>3、源码规范，注释清晰，仿真以及测试报告详细充分。10分</td>
                </tr>
                <tr>
                  <td class="awcloudCup_SorePipBac">4.答辩和现场演示</td>
                  <td class="awcloudCup_SorePipBac">10分</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="btn-gwbm" style="background-color: #ccc">报名已结束</div>
      </div>
    </div>

    <div class="container0204 sspt-wrapper">
      <div class="title-font28-0204">赛事平台</div>
      <div class="title-bgimg-0204"></div>
      <div class="title-text-0204">
        海云捷迅提供人工智能边缘实验平台<br />作为本次大赛的赛事平台
      </div>
      <el-row class="content-col18">
        <div class="content-col18-bg"></div>
        <div>赛事平台-人工智能边缘实验平台</div>
      </el-row>
      <el-row class="font14-0204 mgb10"
        >该平台是由海云捷迅研发的云+FPGA+AI综合性平台</el-row
      >
      <div class="point-text font14-0204 mgb10">
        <span></span
        >云端访问，使用SoC网络技术和FPGA远程调试技术，通过云端向参赛队伍提供服务，参赛队伍可以远程接入此平台，仿真、调试。
      </div>
      <div class="point-text font14-0204 mgb10">
        <span></span
        >FPGA，自主研发的人工智能边缘实验平台，将多个FPGA板卡放置在同一个机箱中，为其提供电源接口、网络分配管理单元，形成FPGA资源池，板卡使用的C5
        SoC的FPGA。
      </div>
      <div class="point-text font14-0204">
        <span></span
        >AI，FPGA开发板内置了与百度开源深度学习Paddle-Paddle框架对接的驱动以及FPGA加速器Demo文件，参赛团队可以方便的将模型文件部署到结合Paddle-Paddle框架的FPGA上，测试其效果并调优。
      </div>
      <div style="margin: 30px 0">
        <img
          src="@/assets/myMatch/2021p/人工智能边缘实验平台1移动端.png"
          width="100%"
        />
      </div>
      <div style="margin-bottom: 50px">
        <img
          src="@/assets/myMatch/2021p/人工智能边缘实验平台2移动端.png"
          width="100%"
        />
      </div>
      <el-row class="content-col18">
        <div class="content-col18-bg"></div>
        <div>人工智能一体机解决方案</div>
      </el-row>
      <div class="point-text font14-0204 mgb10">
        <span></span>提供人工智能模型训练，用于端到端的实训场景
      </div>
      <div class="point-text font14-0204 mgb10">
        <span></span>人工智能专业的开箱即用一站式解决方案
      </div>
      <div class="point-text font14-0204 mgb10">
        <span></span>提供适用的实验与科研环境
      </div>
      <div class="point-text font14-0204" style="margin-bottom: 30px">
        <span></span>提升学生动手操作、项目实践能力
      </div>
      <div>
        <img
          src="@/assets/myMatch/2021p/云端算法训练-网页版0409_20210412.jpg"
          width="100%"
        />
      </div>
    </div>
    <div class="container0204 yysl-wrapper">
      <div class="title-font28-0204">应用示例</div>
      <div class="title-bgimg-0204"></div>
      <div class="title-text-0204">
        赛事平台应用示例介绍，<br />包括高校应用及产品应用
      </div>
      <el-row class="content-col18">
        <div class="content-col18-bg"></div>
        <div>高校应用</div>
      </el-row>
      <el-row class="font14-0204" style="margin-bottom: 20px"
        >电子科技大学&nbsp;&nbsp;重庆大学&nbsp;&nbsp;重庆邮电大学<br />重庆交通大学</el-row
      >
      <!-- <div class="gxyy-img-wrapper">
            <img src="@/assets/myMatch/2021p/4yingyongshili_img_1.jpg" width="100%">
            <img src="@/assets/myMatch/2021p/4yingyongshili_img_2.jpg" width="100%">
            <img src="@/assets/myMatch/2021p/4yingyongshili_img_3.jpg" width="100%">
        </div> -->
      <el-row :gutter="7" style="margin-bottom: 40px">
        <el-col :span="8"
          ><img
            src="@/assets/myMatch/2021p/4yingyongshili_img_1.jpg"
            width="100%"
        /></el-col>
        <el-col :span="8"
          ><img
            src="@/assets/myMatch/2021p/4yingyongshili_img_2.jpg"
            width="100%"
        /></el-col>
        <el-col :span="8"
          ><img
            src="@/assets/myMatch/2021p/4yingyongshili_img_3.jpg"
            width="100%"
        /></el-col>
      </el-row>
      <el-row class="content-col18">
        <div class="content-col18-bg"></div>
        <div>产品应用</div>
      </el-row>
      <el-row class="font14-0204" style="margin-bottom: 20px"
        >采用赛事平台的Demo工程，基于Mobilenet
        V1-SSD的物体分类模型，提供给参赛团队做参考，发挥同学们的创造力，给参赛团队更大的发挥空间。</el-row
      >
      <el-row :gutter="7" type="flex" justify="center">
        <el-col :span="8"
          ><img
            src="@/assets/myMatch/2021p/4yingyongshili_img_4.jpg"
            width="100%"
        /></el-col>
        <el-col :span="8"
          ><img
            src="@/assets/myMatch/2021p/4yingyongshili_img_5.jpg"
            width="100%"
        /></el-col>
      </el-row>
    </div>
    <div class="container0204 jczx-wrapper" style="background-color: #242935">
      <div class="title-font28-0204" style="color: #fff">精彩资讯</div>
      <div class="title-bgimg-0204"></div>
      <div class="title-text-0204" style="color: #d9d9d9">
        实时传递大赛最新动态
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4370','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/zongjuesai-0811.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">关于第五届集创赛全国总决赛参赛事项的通知</div>
          <div class="date">2021-8-10</div>
          <div class="description">
            第五届集创赛全国总决赛将于2021年8月26日-28日在线上举行
          </div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4361','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/mingyuanbei-0811-340.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">
            第五届集创赛“晶丰明源杯”华东分赛区决赛圆满完成【附获奖名单】
          </div>
          <div class="date">2021-8-6</div>
          <div class="description">“晶丰明源杯”华东分赛区决赛圆满完成</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4347','_blank')"
      >
        <div class="top">
          <img src="@/assets/myMatch/2021p/xinhaibei-0811.jpg" height="227px" />
        </div>
        <div class="bottom">
          <div class="title">
            第五届集创赛“芯海杯” 华中分赛区决赛圆满完成【附获奖名单】
          </div>
          <div class="date">2021-7-30</div>
          <div class="description">
            第五届集创赛“芯海杯” 华中分赛区决赛圆满完成
          </div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4331','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/06-finals-8-2-340.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">
            第五届集创赛华东分赛区决赛参赛事项的补充通知【附答辩安排】
          </div>
          <div class="date">2021-7-29</div>
          <div class="description">华东分赛区决赛参赛事项的补充通知</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4315','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/05--finals-8-2-340.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">
            第五届集创赛“芯海杯”华南分赛区决赛圆满完成【附获奖名单】
          </div>
          <div class="date">2021-7-28</div>
          <div class="description">“芯海杯”华南分赛区决赛圆满完成</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4313','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/04-online-finals-8-2-340.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">
            关于第五届集创赛华东分赛区决赛改为线上举行的紧急通知
          </div>
          <div class="date">2021-7-27</div>
          <div class="description">华东分赛区决赛改为线上举行</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4311','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/03-onlinefinals-8-2-340.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">
            关于第五届集创赛华中分赛区决赛改为线上举行的紧急通知
          </div>
          <div class="date">2021-7-26</div>
          <div class="description">华中分赛区决赛改为线上举行</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4303','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/02-finals-8-2-340.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">
            第五届集创赛华中分赛区决赛参赛事项的补充通知【附答辩安排】
          </div>
          <div class="date">2021-7-26</div>
          <div class="description">华中分赛区决赛参赛事项的补充通知</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4267','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/08-southwest-340_20210721.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">第五届集创赛西南分赛区决赛答辩安排</div>
          <div class="date">2021-7-19</div>
          <div class="description">西南分赛区决赛答辩安排。</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4263','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/07-Southwest-340_20210721.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">第五届集创赛西南分赛区决赛参赛通知</div>
          <div class="date">2021-7-9</div>
          <div class="description">西南分赛区决赛参赛通知。</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4296','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/01-finals-8-2-340.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">
            第五届集创赛东北分赛区决赛通知暨创新发展线上论坛
          </div>
          <div class="date">2021-7-7</div>
          <div class="description">东北分赛区决赛通知暨创新发展线上论坛</div>
        </div>
      </div>

      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4272','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/06-Division-340_20210721.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">第五届集创赛分赛区决赛 杯赛答辩要求</div>
          <div class="date">2021-7-6</div>
          <div class="description">第五届集创赛分赛区决赛 杯赛答辩要求。</div>
        </div>
      </div>
      <div
        class="lbt-li-0204"
        onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4258','_blank')"
      >
        <div class="top">
          <img
            src="@/assets/myMatch/2021p/05-Division-340_20210721.jpg"
            height="227px"
          />
        </div>
        <div class="bottom">
          <div class="title">第五届集创赛分赛区决赛参赛相关问题答疑</div>
          <div class="date">2021-7-5</div>
          <div class="description">
            参赛队伍必看，分赛区决赛参赛相关补充说明。
          </div>
        </div>
      </div>
      <div class="btn-zk" @click="btnZk" v-show="!show">
        展开<span class="iconfont icon-zhankai"></span>
      </div>
      <div v-show="show">
        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4251','_blank')"
        >
          <div class="top">
            <img
              src="@/assets/myMatch/2021p/04-Promotion-340_20210721.jpg"
              height="227px"
            />
          </div>
          <div class="bottom">
            <div class="title">第五届集创赛初赛晋级名单公示通知</div>
            <div class="date">2021-7-2</div>
            <div class="description">
              第五届全国大学生集成电路创新创业大赛初赛晋级名单已公示。
            </div>
          </div>
        </div>
        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4240','_blank')"
        >
          <div class="top">
            <img
              src="@/assets/myMatch/2021p/03-Preliminaries2-340_20210721.jpg"
              height="227px"
            />
          </div>
          <div class="bottom">
            <div class="title">初赛通知-附件2：提交格式及要求</div>
            <div class="date">2021-5-26</div>
            <div class="description">
              第五届集创赛初赛通知，附件2：提交格式及要求
            </div>
          </div>
        </div>
        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4243','_blank')"
        >
          <div class="top">
            <img
              src="@/assets/myMatch/2021p/02-Preliminaries1-340_20210721.jpg"
              height="227px"
            />
          </div>
          <div class="bottom">
            <div class="title">初赛通知-附件1：阶段报告及杯赛题目作品要求</div>
            <div class="date">2021-5-26</div>
            <div class="description">
              第五届集创赛初赛通知-附件1：阶段报告及海云捷迅杯赛题目作品要求
            </div>
          </div>
        </div>
        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4234','_blank')"
        >
          <div class="top">
            <img
              src="@/assets/myMatch/2021p/01-Preliminaries-340_20210721.jpg"
              height="227px"
            />
          </div>
          <div class="bottom">
            <div class="title">第五届集创赛初赛通知</div>
            <div class="date">2021-5-26</div>
            <div class="description">
              第五届集创赛即将进入初赛阶段，大赛组委会拟于6月举办初赛。初赛需要提交的材料分为阶段报告和杯赛题目作品两部分。
            </div>
          </div>
        </div>
        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4130','_blank')"
        >
          <div class="top">
            <img src="@/assets/myMatch/2021p/jingcaizixun.jpg" />
          </div>
          <div class="bottom">
            <div class="title">2021集成电路产教融合高峰论坛重磅开启！</div>
            <div class="date">2021-5-8</div>
            <div class="description">
              5月14日至16日在重庆市举办“2021全国集成电路产教融合高峰论坛”。本次高峰论坛主题为“构建集成电路产教融合新生态，推动一级学科建设与人才培养”。
            </div>
          </div>
        </div>

        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4050','_blank')"
        >
          <div class="top">
            <img src="@/assets/myMatch/2021p/重要通知20210316.jpg" />
          </div>
          <div class="bottom">
            <div class="title">关于延迟第五届集创赛报名截止时间的通知</div>
            <div class="date">2021-3-15</div>
            <div class="description">
              第五届全国大学生集成电路创新创业大赛报名截止时间延至2021年3月31日24:00
            </div>
          </div>
        </div>

        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4036','_blank')"
        >
          <div class="top">
            <img src="@/assets/myMatch/2021p/7点20210310.jpg" />
          </div>
          <div class="bottom">
            <div class="title">海云捷迅杯赛，不得不说的7个“知识点”</div>
            <div class="date">2021-3-9</div>
            <div class="description">
              云上芯探索
              AI谱未来，海云捷迅助力集成电路创新开启。第五届全国大学生集成电路创新创业大赛-海云捷迅杯赛，不得不说的7个“知识点”
            </div>
          </div>
        </div>

        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4030','_blank')"
        >
          <div class="top">
            <img src="@/assets/myMatch/2021p/倒计时10天20210310.jpg" />
          </div>
          <div class="bottom">
            <div class="title">倒计时10天！第五届集创赛喊你来报名！</div>
            <div class="date">2021-3-5</div>
            <div class="description">
              由海云捷迅作为企业代表参与赛题设置的海云捷迅杯在FPGA设计与应用赛道静待大家参与，其赛题为《基于FPGA
              C5Soc的MobileNetV1
              SSD目标检测方案设计》，第五届集创赛海云捷迅杯官网已正式上线
            </div>
          </div>
        </div>

        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=3986','_blank')"
        >
          <div class="top">
            <img src="@/assets/myMatch/2021p/jczx0204_1.jpg" />
          </div>
          <div class="bottom">
            <div class="title">FPGA+AI双剑合璧—海云捷迅杯助你练就正宗芯法</div>
            <div class="date">2021-2-8</div>
            <div class="description">
              海云捷迅杯赛，将FPGA与AI应用双剑合璧， Intel FPGA
              C5Soc，SSD模型框架，CNN加速，百度paddle-paddle框架等众多关键技术与平台融于一体，助你练就人工智能时代正宗芯法，成为直面前沿挑战的弄潮儿。
            </div>
          </div>
        </div>

        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=3973','_blank')"
        >
          <div class="top">
            <img src="@/assets/myMatch/2021p/jczx0204_2.jpg" />
          </div>
          <div class="bottom">
            <div class="title">
              扛起人工智能教育大旗——海云捷迅执行承办第五届全国大学生集成电路创新创业大赛
            </div>
            <div class="date">2021-1-29</div>
            <div class="description">
              2021年1月中旬，海云捷迅及重庆邮电大学执行承办的第五届全国大学生集成电路创新创业大赛启动仪式在西部（重庆）科学城举行。
            </div>
          </div>
        </div>

        <div
          class="lbt-li-0204"
          onclick="javascript:window.open('https://www.awcloud.com/news_detail.html?id=4001','_blank')"
        >
          <div class="top">
            <img src="@/assets/myMatch/2021p/jczx0204_3.jpg" />
          </div>
          <div class="bottom">
            <div class="title">第五届集创赛启动仪式在重庆市举行</div>
            <div class="date">2021-1-15</div>
            <div class="description">
              1月12日第五届全国大学生集成电路创新创业大赛 启动仪式在重庆市举行。
            </div>
          </div>
        </div>
      </div>
      <div class="btn-zk" @click="btnZk" v-show="show">
        收起<span class="iconfont icon-shouqi"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    btnZk() {
      this.show = !this.show;
    },
  },
};
</script>
